/**
 * Shared Logging Types
 * 
 * Contains enums and interfaces shared between the client logger (logger.ts)
 * and server logger (server-logger.ts). Extracted to avoid server-logger.ts
 * transitively importing client-only code through logger.ts.
 */

export enum LogLevel {
    DEBUG = 'debug',
    INFO = 'info',
    WARN = 'warn',
    ERROR = 'error'
}

export enum LogCategory {
    AUTH = 'auth',
    ROLE = 'role',
    ACCESS = 'access',
    NETWORK = 'network',
    GENERAL = 'general',
    UI = 'ui',
    API = 'api',
    DB = 'db',
    CAMERA = 'camera'
}

export interface LogContext {
    component?: string;
    userId?: string;
    userEmail?: string;
    sessionId?: string;
    category?: LogCategory;
    [key: string]: any;
}

export const LOG_LEVEL_PRIORITY: Record<LogLevel, number> = {
    [LogLevel.DEBUG]: 0,
    [LogLevel.INFO]: 1,
    [LogLevel.WARN]: 2,
    [LogLevel.ERROR]: 3
};
